import React, { useState } from 'react';
import { LegacyStack, TextStyle, Link, Form, Button } from '@shopify/polaris';
import { TextField } from '@thinkwell/react.polaris'
import ClassroomRegistrationForm from './ClassroomRegistrationForm';
import EditTempAccess from './EditTempAccess';

export default function ClassroomRegistration(props) {
  const section = props.section

  return (
    <div className="section-info" title={section.section_id} style={{display: props.visible ? 'block' : 'none'}}>
      <div className="name">{`${section.school} - ${section.course} - ${section.section}`}</div>
      { section.variant_id ?
        (<div>
          <LegacyStack>
            <ClassroomRegistrationForm section={section} buttonText="Register" />
            { section.temp_access ? (
              <EditTempAccess section={section} />
            ) : null }
            { section.organization_allow_retakes ? <button className="button orange registration-link" onClick={() => props.onRetakeClicked()}>Retake</button> : null }
          </LegacyStack>
        </div>) :
        (<div className="message"><strong>This class is currently unavailable for registration. Please contact our <a href="mailto:support@thinkwell.com">support</a>.</strong></div>)
      }
    </div>)
}
